var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%"},attrs:{"id":"chart"}},[_c('VueApexCharts',{attrs:{"type":"bar","height":"400","width":"100%","options":_vm.chartOptions,"series":_vm.filteredBarData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }